import React from 'react'
import { Text, View, StyleSheet} from '@react-pdf/renderer';
import {Copyright} from '@material-ui/icons';

// Create styles
const styles = StyleSheet.create({
    
    section: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      height: '10vh',
      flex: '0.5',
      marginTop: '10px',
    },
    footerText: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'gray',
        fontSize: '10px',
    }
  });

const PdfFooter = () => {
    return (
        <View fixed style={styles.section}>
            <View>
            <Text style={styles.footerText}><Copyright/> Generated By KNC Tech PV Generator 2022</Text>
            </View>
        </View>
    )
}

export default PdfFooter
